import moment from "moment";
import axios from "./axios";

export const getToken = async () => {
  const res = await axios.get("api/bpoint/transaction_token");
  return res.data.data.key;
};

export const validateDD = (newDirectDebit) => {
  const { direct_debit_bsb, direct_debit_number, direct_debit_name } =
    newDirectDebit;

  const errors = {};

  return new Promise((resolve, reject) => {
    if (window.CBA.ValidateBSB(direct_debit_bsb) === false) {
      errors.direct_debit_bsb = `Invalid BSB ${direct_debit_bsb}`;
    }

    if (window.CBA.ValidateAccountNumber(direct_debit_number) === false) {
      errors.direct_debit_number = "Invalid Account Number";
    }

    if (window.CBA.IsNullOrEmptyString(direct_debit_name) !== false) {
      errors.direct_debit_name = "Invalid Account Name";
    }
    if (Object.keys(errors).length === 0) {
      resolve(getToken());
    } else {
      reject(errors);
    }
  });
};

export const validateCC = (newCreditCard) => {
  const {
    credit_card_number,
    credit_card_expiry_date,
    credit_card_ccv,
    credit_card_name,
  } = newCreditCard;

  const expiry = moment(credit_card_expiry_date, "MM/YYYY");

  const errors = {};

  return new Promise((resolve, reject) => {
    if (window.CBA.ValidateCardNumber(credit_card_number) === false) {
      errors.credit_card_number = "Invalid Card Number";
    }

    if (
      window.CBA.ValidateExpiry(expiry.format("MM"), expiry.format("YYYY")) ===
      false
    ) {
      errors.credit_card_expiry_date = "Invalid Expiry Date";
    }

    if (window.CBA.ValidateCVC(credit_card_ccv) === false) {
      errors.credit_card_ccv = "Invalid CCV Number";
    }

    if (window.CBA.IsNullOrEmptyString(credit_card_name) !== false) {
      errors.credit_card_name = "Invalid Account Name";
    }

    if (Object.keys(errors).length === 0) {
      resolve(getToken());
    } else {
      reject(errors);
    }
  });
};

const saveDirectDebitOrCreditCard = (result, user_id, type, config) => {
  const post = {
    ...result,
    user_id,
  };

  return new Promise((resolve, reject) => {
    if (result.AjaxResponseType === 0 && result.ApiResponseCode === 0) {
      return axios
        .post(`api/bpoint/callback/${type}`, post, config)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    }
    reject(result.Errors);
  });
};

export const storeDirectDebit = async (
  values,
  callback,
  setErrors = () => {},
  config
) => {
  try {
    const token = await validateDD(values);
    const bpdata = {
      AuthKey: token,
      Crn1: "WebAccountUpdate",
      Type: "BANKACCOUNT",
      EmailAddress: values.email,
      BankAccountName: values.direct_debit_name,
      BankAccountNumber: values.direct_debit_number,
      BSBNumber: values.direct_debit_bsb,
      AcceptBankAccountTerms: 1,
      CallbackFunction: async (result) => {
        if (result.ApiResponseCode === 0) {
          await saveDirectDebitOrCreditCard(
            result,
            values.user_id,
            "direct_debit",
            config
          ).then(async (res) => {
            const newFormStateValues = { ...values, accounts: res };
            await callback(newFormStateValues, result);
          });
        } else {
          result.Errors.forEach((error) => {
            switch (error.PropertyName) {
              case "BsbNumber":
                setErrors({ direct_debit_bsb: error.Message });
                break;
              default:
                break;
            }
          });
        }
      },
    };
    window.CBA.ProcessAddToken(bpdata);
  } catch (error) {
    console.log(error);
  }
};

export const storeCreditCard = async (values, setValues, setErrors, config) => {
  const token = await validateCC(values);
  const expiry = moment(values.credit_card_expiry_date, "MM/YYYY");
  const bpdata = {
    AuthKey: token,
    Crn1: "WebAccountUpdate",
    Type: "CREDITCARD",
    EmailAddress: values.email,
    CardHolderName: values.credit_card_name,
    CardNumber: values.credit_card_number,
    ExpiryMonth: expiry.format("MM"),
    ExpiryYear: expiry.format("YY"),
    AcceptBankAccountTerms: 1,
    CallbackFunction: (result) => {
      if (result.ApiResponseCode === 0) {
        saveDirectDebitOrCreditCard(
          result,
          values.user_id,
          "credit_card",
          config
        ).then((res) => {
          const newFormStateValues = { ...values, accounts: res };
          setValues(newFormStateValues);
        });
      } else {
        result.Errors.forEach((error) => {
          setErrors({ credit_card_number: error.Message });
        });
      }
    },
  };
  window.CBA.ProcessAddToken(bpdata);
};

export async function doBpointCallback(token, data) {
  return {}; // fetchPost(`${Site.api_url}fmsync/bpoint_callback/${token}`, data);
}
